import { z } from 'zod';
export const PaymentProviderSchema = z.enum(['manual', 'stripe', 'iyzico']);
export const PaymentStatusSchema = z.enum([
    'pending',
    'completed',
    'failed',
    'refunded',
    'cancelled',
]);
export const PaymentSchema = z.object({
    id: z.string().uuid(),
    userId: z.string().uuid(),
    amount: z.number().positive(),
    currency: z.string().length(3),
    status: PaymentStatusSchema,
    provider: PaymentProviderSchema,
    providerPaymentId: z.string().optional(),
    description: z.string().optional(),
    metadata: z.record(z.string(), z.unknown()).optional(),
    createdAt: z.string().datetime(),
    updatedAt: z.string().datetime(),
});
export const CreatePaymentSchema = z.object({
    amount: z.number().positive(),
    currency: z.string().length(3).default('TRY'),
    description: z.string().optional(),
    metadata: z.record(z.string(), z.unknown()).optional(),
});
// ============================================================================
// PDF #12 — Taksit planı
// ============================================================================
export const InstallmentStatusSchema = z.enum(['pending', 'paid', 'waived', 'overdue']);
export const PaymentInstallmentSchema = z.object({
    id: z.string().uuid(),
    planId: z.string().uuid(),
    installmentNo: z.number().int().min(1),
    amount: z.number().nonnegative(),
    dueAt: z.string().datetime(),
    status: InstallmentStatusSchema,
    paidAt: z.string().datetime().nullable(),
    markedPaidById: z.string().uuid().nullable(),
    notes: z.string().nullable(),
    createdAt: z.string().datetime(),
    updatedAt: z.string().datetime(),
});
export const PaymentPlanSchema = z.object({
    id: z.string().uuid(),
    userId: z.string().uuid(),
    courseId: z.string().uuid().nullable(),
    description: z.string().nullable(),
    totalAmount: z.number().nonnegative(),
    currency: z.string().length(3),
    createdById: z.string().uuid().nullable(),
    createdAt: z.string().datetime(),
    updatedAt: z.string().datetime(),
    installments: z.array(PaymentInstallmentSchema).optional(),
    // computed
    paidAmount: z.number().nonnegative().optional(),
    remainingAmount: z.number().nonnegative().optional(),
    // optional join — for admin lists
    userName: z.string().nullable().optional(),
    courseName: z.string().nullable().optional(),
});
export const CreatePaymentPlanSchema = z.object({
    userId: z.string().uuid(),
    courseId: z.string().uuid().optional(),
    description: z.string().max(500).optional(),
    totalAmount: z.coerce.number().positive(),
    currency: z.string().length(3).default('TRY'),
    installmentCount: z.coerce.number().int().min(1).max(36),
    firstDueAt: z.string().datetime(),
    // monthly default = 30; allows weekly (7) or custom; service splits evenly.
    intervalDays: z.coerce.number().int().min(1).max(365).default(30),
});
export const MarkInstallmentPaidSchema = z.object({
    notes: z.string().max(500).optional(),
});
export const WebhookEventSchema = z.object({
    provider: PaymentProviderSchema,
    eventType: z.string(),
    paymentId: z.string(),
    data: z.record(z.string(), z.unknown()),
});
//# sourceMappingURL=payment.js.map